export default __webpack_public_path__ + "static/media/opensans-extrabolditalic-webfont.7214cb5d.woff";